import { render } from "./index.vue.js?vue&type=template&id=86ba17fa!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./index.vue?vue&type=template&id=86ba17fa"
const script = {  }

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__